import { render, staticRenderFns } from "./icon-add.vue?vue&type=template&id=e6cc88be&scoped=true&"
import script from "./icon-add.vue?vue&type=script&lang=js&"
export * from "./icon-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cc88be",
  null
  
)

export default component.exports